import { useEffect, useState, RefObject } from 'react';

/**
 * Tracks the current width of a DOM element and keeps it in sync
 * with window resize events.
 */
export function useElementWidth<T extends HTMLElement>(ref: RefObject<T>) {
  const [width, setWidth] = useState<number | null>(null);

  useEffect(() => {
    const updateWidth = () => {
      if (!ref.current) return;
      const nextWidth = ref.current.getBoundingClientRect().width;
      setWidth((prev) => (prev === nextWidth ? prev : nextWidth));
    };

    updateWidth();

    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, [ref]);

  return width;
}

